/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import Footer from "../../examples/Footer";
import TextField from "@mui/material/TextField";
import TabComponent from "components/TabComponent";
import Button from "../../components/ButtonUse.jsx";
import axios from "axios";
import { uploadFile } from "react-s3";
import useSWR from "swr";
import Select from "react-select";
import { baseURL } from "utils/api";
import LoaderComponent from "components/Loader";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import config from "../../utils/awsCnfig";
import { IoIosRemoveCircleOutline } from "react-icons/io";
import CloseIcon from "@mui/icons-material/Close";
import tempImage from "../../assets/images/clothes.avif";
import ModalComponent from "components/MDTypography/ModalComponent";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import React from "react";
import "./tables.css";
import { useParams } from "react-router-dom";

window.Buffer = window.Buffer || require("buffer").Buffer;
import placeholder from "../../assets/images/placeholder.png";
import { baseUrl } from "utils/api";
import { toast } from "react-toastify";
import { IconButton } from "@mui/material";
import { MdOutlinePreview } from "react-icons/md";
import { display } from "@mui/system";
// import tempImage from "../../assets/images/clothes.jpg";

// import Button from "../../components/ButtonUse.jsx";
// Data

// Dashboard components
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
function EditProduct() {
  //   fetch category names for select option-:
  const [ruSubject, setRuSubject] = useState("");
  const [ruAttribute, setRuAttribute] = useState("");
  const [productData, setProductData] = useState(null);
  const [price, setPrice] = useState("");
  const [mOQ, setmOQ] = useState("");
  const [quantity, setQuantity] = useState("");
  const [sendGoodAddressText, setSendGoodAddressText] = useState("");
  const [unit, setUnit] = useState("");
  const [length, setLength] = useState("");
  const [width, setWidth] = useState("");
  const [height, setHeight] = useState("");
  const [unitWeight, setUnitWeight] = useState("");
  const [suttleWeight, setSuttleWeight] = useState("");
  const [storeName, setStoreName] = useState("");
  const [salePrice, setSalePrice] = useState("");
  const [categoryName, setCategoryName] = useState("");

  const fetchData = async (url) => {
    try {
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };
  const { data, error } = useSWR(`${baseURL}/admin/fetch/categorynames`, fetchData);

  // declare options for react-select
  const options = data;
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const handleClose = () => setOpenDialog(false);
  const [category, setCategory] = useState(null);
  const location = useLocation();

  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [formLoading, setFormLoading] = useState(false);
  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      setSelectedFile(file);
      const imageUrl = URL.createObjectURL(file);
      setPreviewUrl(imageUrl);
    }
  };
  const [attributes, setAttrributes] = useState([
    {
      text: "",
    },
  ]);
  const [colorOptions, setColotherOptions] = useState([
    {
      value: "",
      quantity: "",
      subtractStock: "",
      sellingprice: "",
      price: "",
      priceType: "",
      image: "",
      preview: "",
      points: "",
      pointType: "",

      weight: "",
      weightType: "",
    },
  ]);
  const [sizeOptions, setSizeOptions] = useState([
    {
      value: "",
      quantity: "",
      subtractStock: "",
      selectedValue: "",
      price: "",
      image: "",
      preview: "",
      priceType: "",
      sellingprice: "",
      points: "",
      pointType: "",
      image: "",
      preview: "",
      weight: "",
      weightType: "",
    },
  ]);
  const [atttribute3, setAttribute3] = useState([
    {
      value: "",
      quantity: "",
      subtractStock: "",
      sellingprice: "",
      price: "",
      priceType: "",
      image: "",
      preview: "",
      points: "",
      pointType: "",

      weight: "",
      weightType: "",
    },
  ]);
  const [productImages, setProductImages] = useState([
    {
      imageUrl: "",
      sortOrder: "",
    },
  ]);

  const [categoryImages, setCategoryImages] = useState([
    {
      image: "",
      preview: "",
    },
  ]);

  const [categoryVid, setCategoryVid] = useState("");

  // upload to aws for color options (attribute 1);
  const uploadFiletoS3ColorOptions = async () => {
    try {
      const updatedColorOptions = colorOptions.map(async (colorOption, i) => {
        const file = colorOption.image;
        console.log(file);

        if (file) {
          const { location } = await uploadFile(file, config);
          colorOption.image = location;

          // Exclude the 'preview' property from the state
          delete colorOption.preview;
        }

        return colorOption;
      });

      const newColorOptions = await Promise.all(updatedColorOptions);
      setColotherOptions(newColorOptions);

      return newColorOptions;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  //  upload to asw s3 for size options(att2)
  const uploadFiletoS3SizeOptions = async () => {
    try {
      const sizeState = [...sizeOptions];

      for (let i = 0; i < sizeState.length; i++) {
        const file = sizeState[i].image;
        console.log(file);
        if (file) {
          const { location } = await uploadFile(file, config);
          sizeState[i].image = location;

          // Exclude the 'preview' property from the state
          delete sizeState[i].preview;
        }
      }

      setSizeOptions(sizeState);
      return sizeState;
    } catch (error) {
      console.log(error);
    }
  };

  // upload to s3 for attribute 3

  const uploadFiletoS3Attr3 = async () => {
    try {
      const sizeState = [...atttribute3];

      for (let i = 0; i < sizeState.length; i++) {
        const file = sizeState[i].image;
        console.log(file);
        if (file) {
          const { location } = await uploadFile(file, config);
          sizeState[i].image = location;

          // Exclude the 'preview' property from the state
          delete sizeState[i].preview;
        }
      }

      setAttribute3(sizeState);
      return sizeState;
    } catch (error) {
      console.log(error);
    }
  };

  // upload category images to s3
  const uploadFiletoS3CategoryImg = async () => {
    try {
      const sizeState = [...categoryImages];

      for (let i = 0; i < sizeState.length; i++) {
        const file = sizeState[i].image;
        console.log(file);
        if (file) {
          const { location } = await uploadFile(file, config);
          sizeState[i].image = location;

          // Exclude the 'preview' property from the state
          delete sizeState[i].preview;
        }
      }

      setCategoryImages(sizeState);
    } catch (error) {
      console.log(error);
    }
  };

  const [formState, setFormState] = useState({

  });
  // console.log(formState,'FormState')
  const [categoryId, setCategoryId] = useState({
    label: "",
    value: "",
  });
  const [attr1Data, setAttr1Data] = useState([]);

  const tabProps = [
    {
      title: "General",
      content: (
        <GeneralDetailsForm
          options={options}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          data={formState}
          setFunc={setFormState}
          categoryId={categoryId}
          ruSubject={ruSubject}
          setRuSubject={setRuSubject}
          categoryName={categoryName}
          setCategoryName={setCategoryName}
        />
      ),
      id: 1,
    },
    {
      title: "Data",
      content: (
        <DataForm
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          data={formState}
          setFunc={setFormState}
          preview={previewUrl}
          selectedFile={selectedFile}
          handleChange={handleFileChange}
          handleClose={handleClose}
          productData={productData}
          setProductData={setProductData}
          price={price}
          setPrice={setPrice}
          mOQ={mOQ}
          setmOQ={setmOQ}
          quantity={quantity}
          setQuantity={setQuantity}
          unit={unit}
          setUnit={setUnit}
          length={length}
          setLength={setLength}
          width={width}
          setWidth={setWidth}
          height={height}
          setHeight={setHeight}
          unitWeight={unitWeight}
          setUnitWeight={setUnitWeight}
          suttleWeight={suttleWeight}
          setSuttleWeight={setSuttleWeight}
          storeName={storeName}
          setStoreName={setStoreName}
          salePrice={salePrice}
          setSalePrice={setSalePrice}
          sendGoodAddressText={sendGoodAddressText}
          setSendGoodAddressText={setSendGoodAddressText}
        />
      ),
      id: 2,
    },

    {
      title: "RUAttributes",
      content: (
        <AttributesForm
          data={formState}
          setFunc={setFormState}
          ruAttribute={ruAttribute}
          setRuAttribute={setRuAttribute}
        />
      ),
      id: 4,
    },

    {
      title: "Options",
      content: (
        <OptionsForm
          colorOptions={colorOptions}
          sizeOptions={sizeOptions}
          setColotherOptions={setColotherOptions}
          setSizeOptions={setSizeOptions}
          atttribute3={atttribute3}
          setAttribute3={setAttribute3}
          attr1Data={attr1Data}
          setAttr1Data={setAttr1Data}
        />
      ),
      id: 6,
    },
    {
      title: "Images",
      content: (
        <ImageForm
          categoryImages={categoryImages}
          setCategoryImages={setCategoryImages}
          categoryVid={categoryVid}
          setCategoryVid={setCategoryVid}
          data={formState}
          setFunc={setFormState}
        />
      ),
      id: 7,
    },
    {
      title: "SEO",
      content: <SeoForm data={formState} setFunc={setFormState} />,
      id: 8,
    },
  ];

  // fetch product by id to autofill the form-:
  // console.log(location.state);
  // useEffect(() => {
  //   async function fetchProduct() {
  //     try {
  //       setLoading(true);
  //       const { data } = await axios.get(`${baseURL}/products/getProducts?page=1/${location.state}`);
  //       console.log(data,"aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
  //       setLoading(false);
  //       // setCategory()
  //       setFormState({
  //         ...formState,
  //         productName: response?.data?.data?.products?.ruSubject,
  //         // categoryName: data.product?.categoryName,
  //         price: response?.data?.data?.products?.price,

  //         ruSubject: response?.data?.data?.products?.ruSubject,
  //         sumCarriage: response?.data?.data?.products?.sumCarriage,
  //         salePrice: response?.data?.data?.products?.salePrice,
  //         taxClass:response?.data?.data?.products?.taxClass,
  //         qtyInStock: response?.data?.data?.products?.qtyInStock,
  //         mOQ:response?.data?.data?.products?.mOQ,
  //         storeName: response?.data?.data?.products?.storeName,
  //         subtractStockPrice: response?.data?.data?.products?.subtractStock,
  //         sendGoodAddressText: response?.data?.data?.products?.sendGoodAddressText,
  //         suttleWeight:response?.data?.data?.products?.suttleWeight,
  //         length: response?.data?.data?.products?.length,
  //         width: response?.data?.data?.products?.width,
  //         height: response?.data?.data?.products?.height,
  //         weightClass: response?.data?.data?.products?.weightClass,
  //         rAttribute: response?.data?.data?.products?.ruAttribute[0],

  //       });
  //       // setSelectedCategory({ value: data?.product?.categoryId, label: data?.product?.categoryId })
  //       // setCategoryId({ ...categoryId, label: data?.product?.categoryId, value: data?.product?.categoryId });
  //       // setColotherOptions(data?.product?.attr1);
  //       // setSizeOptions(data?.product?.attr2);
  //       // setAttribute3(data?.product?.attr3);
  //       // console.log(data?.product?.attr1);
  //     } catch (error) {

  //     }
  //   }
  //   fetchProduct();
  // }, [location.state])

  // const [loading, setLoading] = useState(false);
  // const [product, setProduct] = useState({
  //   ruSubject: "Зимняя мужская утепленная бархатная куртка средней длины с капюшоном",
  // });

  // useEffect(() => {
  //   async function fetchProduct() {
  //     try {
  //       setLoading(true);
  //       const response = await axios.get(
  //         `https://jumunona.onrender.com/admin/products/getProducts?page=1${location.state}`
  //       );
  //       setLoading(false);

  //       if (response.data && response.data.products && response.data.products.length > 0) {
  //         // Extracting the ruSubject values of all products
  //         const ruSubjects = response.data.products.map((product) => product.ruSubject);
  //         // Setting the first ruSubject value to the state
  //         setProduct({ ruSubject: ruSubjects[0] });
  //         console.log(ruSubjects, "hhhhhhhhhhhhhhhhh");
  //       } else {
  //         console.log("No products found");
  //       }
  //     } catch (error) {
  //       console.error("Error fetching products:", error);
  //     }
  //   }

  //   fetchProduct();
  // }, [location.state]);

  // const handleInputChange = (e) => {
  //   setProduct({ ruSubject: e.target.value });
  // };

  // console.log(formState);
  // console.log(formState.categoryName);
  // const categoryId = formState.categoryName?.value;

  // handler for mark product as checked

  const currentDate = new Date();
  const currentTime = currentDate.toLocaleTimeString([], { hour12: true });
  console.log("location", location.pathname.split('/'));
  async function handleCheckProduct() {
    try {
      setFormLoading(true);
      const res = await axios.put(`${baseUrl}/products/checkUnCheck/${location.pathname.split('/')[2]}`, {
        isChecked: true,
        updatedAtTime: currentTime,
      });
      setFormLoading(false);
      navigate("/products-list");
      // console.log(res);
    } catch (error) {
      console.log(error);
      setFormLoading(false);
    }
  }

  // handler for marking product as unchecked-:

  async function markUnchecked() {
    try {
      setFormLoading(true);
      const res = await axios.put(`${baseUrl}/products/checkUnCheck/${location.pathname.split('/')[2]}`, {
        isChecked: false,
        updatedAtTime: currentTime,
      });
      setFormLoading(false);
      navigate("/products-list");
      console.log(res);
    } catch (error) {
      console.log(error);
      setFormLoading(false);
    }
  }

  // const handleUpdateProduct = async (e) => {
  //   e.preventDefault();
  //   setFormLoading(true);
  //   const attr1 = await uploadFiletoS3ColorOptions();
  //   const attr2 = await uploadFiletoS3SizeOptions();
  //   const attr3 = await uploadFiletoS3Attr3();
  //   await uploadFiletoS3CategoryImg();
  //   try {
  //     // e.preventDefault();
  //     // setFormLoading(true);

  //     const res = await axios.post(
  //       `${baseURL}/product/edit-product/${location.state}`,
  //       {
  //         ...formState,
  //         categoryName: formState.categoryName?.value,
  //         categoryId: formState.categoryName?.value,
  //         updatedAtTime: currentTime,
  //         attr1: attr1,
  //         attr2: attr2,
  //         attr3: attr3,
  //         categoryImages: categoryImages,
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );
  //     if (res.status === 200) {
  //       setFormLoading(false);
  //       console.log(colorOptions);
  //       navigate("/products-list");
  //     }
  //   } catch (error) {
  //     setFormLoading(false);
  //   }
  // };

  const { _id } = useParams();
  const [_id1, set_id1] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    const area = {
      name: ruSubject,
      RUattributes: ruAttribute,
      price,
      quantity,
      unit,
      mOQ,
      length,
      width,
      height,
      unitWeight,
      suttleWeight,
      storeName,
      salePrice,
      sendGoodAddressText,
      ...formState,
      variants: attr1Data
    };
    console.log(area, "UUUUUUUUUUUUUUUUUUUUu");
    const Newarea = Object.entries(area).reduce((acc, [key, value]) => {
      if (value !== '' && value !== undefined && value !== null && value.length > 0 && !(typeof value === 'string' && value.trim().length === 0)) {
        acc[key] = value;
      }
      return acc;
    }, {});
    console.log(Newarea, "UUUUUUUUUUUUUUUUUUUUu");

    try {
      const requestOptions = {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(Newarea),
      };

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/products/updateProductValues/${_id}`,
        requestOptions
      );
      // const attributeResponse= await fetch(`https://jumunona.onrender.com/admin/products/updateProductsAttribute/${_id}`, requestOptions)
      // console.log(_id, "ggggggggggggggggggg");
      if (!response.ok) {
        const error = await response.text();
        throw new Error(error);
      }
      toast.success(
        <div className="toast_div_success ">
          <div className="success-Heading">Save</div>
          <div className="toastMessage">
            <span className="Toast--Black">
              <span>Products Updated Succesfully</span>
            </span>
          </div>
        </div>, {
        position: "top-right"
      });
      const data = await response.json();
      // setRuSubject("");
      // setRuAttribute("");
      // setProductData("");
      // setPrice("");
      // setmOQ("");
      // setQuantity("");
      // setUnitWeight("");
      // setUnit("");
      // setLength("");
      // setWidth("");
      // setHeight("");
      // setUnitWeight("");
      // setSuttleWeight("");
      // setStoreName("");
      // setSalePrice("");
      // setSendGoodAddressText("");
      // setAttribute3("");
      // set_id1("");
      // setErrorMessage("");
    } catch (error) {
      // setErrorMessage(error.message || "An error occurred while updating data");
      // console.error("There was an error!", error);
    }
  };


  return (
    <DashboardLayout>
      {/* {loading && <LoaderComponent open={true} />} */}
      {formLoading && <LoaderComponent open={true} />}
      <DashboardNavbar />

      <form
        onSubmit={handleSubmit}
        style={{
          background: "white",
          padding: "10px",
          borderRadius: "10px",
          boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
          overflow: "scroll",
        }}
      >
        <div style={{ display: "flex", gap: "20px", justifyContent: "end" }}>
          {formState.isChecked ? <Button
            type={"button"}
            cliclHandler={markUnchecked}
            title={"Un-checked"}
            background={"purple"}
          /> : null}
          {formState.isChecked === false ? <Button
            type={"button"}
            cliclHandler={handleCheckProduct}
            title={"Checked"}
            background={"blue"}
          /> : null}
          <Button title={"Submit"} type={"submit"} background={"green"} />
          <Button
            cliclHandler={() => {
              navigate(-1);
            }}
            title={"Cancel"}
            background={"red"}
            type={"button"}
          />
        </div>

        <TabComponent tabContent={tabProps} />
      </form>

      <Footer />
    </DashboardLayout>
  );
}

export default EditProduct;

function GeneralDetailsForm({
  data,
  options,
  setFunc,
  selectedCategory,
  setSelectedCategory,
  categoryId,
  setRuSubject,
  ruSubject,
  categoryName,
  setCategoryName
}) {
  // console.log(selectedCategory);
  useEffect(() => {
    setSelectedCategory(selectedCategory);
    setFunc({ ...data, categoryName: selectedCategory });
  }, [selectedCategory]);
  const defaultValue = [{ label: categoryId?.label, value: categoryId?.value }];

  const { _id } = useParams();
  const location = useLocation();
  const fetchData = async (_id) => {
    console.log(_id, "test");
    try {
      const apiUrl = `${process.env.REACT_APP_BASE_URL}/products/getproductV3/${_id}`;
      const response = await axios.get(apiUrl);
      const data = await response.data;
      // if(data.data){
      //   setFormState(data.data);
      // }
      const catData = await axios.get(`${process.env.REACT_APP_BASE_URL}/categories/getCategoryDetailsV2?categoryId=${data.categoryId}`)
      console.log(catData, 'CatData')
      console.log(data.name, 'DDDPPPP')
      setFunc(data);
      if (data && data.name) {
        setRuSubject(data.name);
      } if (data && data.categoryId) {
        setCategoryName(data.categoryId);
      }
      else {
        console.error("Invalid API response or missing data");
      }


      console.log(data, "testing");
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (_id) {
      // const productId = location.state?.productId;
      fetchData(_id);
    }
    console.log(_id, "ddddddddddddddd");
  }, [location.state?.productId, _id]);

  const handleInputChange = (e) => {
    setRuSubject(e.target.value);
  };

  return (
    <>
      <div style={{ padding: "5px" }}>
        <div style={{ display: "flex", gap: "20px", flexDirection: "column" }}>
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw", marginTop: "5vh" }}
            label="RU Subject"
            placeholder="Example"
            value={ruSubject}
            onChange={handleInputChange}
            variant="outlined"
          />
          <div className="flex flex-col gap-3 pb-20">
            <span className="text-sm">Category Name</span>
            {/* categoryId */}
            {/* <Select
              options={options}
              defaultValue={selectedCategory}
              onChange={setSelectedCategory}
            /> */}
            <TextField
              id="outlined-basic"
              sx={{ width: "60vw", marginTop: "5vh" }}
              label="Category Name"
              placeholder="Category Name"
              value={categoryName}
              // onChange={handleInputChange}
              variant="outlined"
            />
          </div>
        </div>
      </div>
    </>
  );
}

function DataForm({
  data,
  setFunc,
  preview,
  selectedFile,
  handleChange,
  openDialog,
  setOpenDialog,
  handleClose,
  productData,
  setProductData,
  price,
  setPrice,
  quantity,
  setQuantity,
  mOQ,
  setmOQ,
  length,
  setLength,
  width,
  setWidth,
  height,
  setHeight,
  unitWeight,
  setUnitWeight,
  suttleWeight,
  setSuttleWeight,
  storeName,
  setStoreName,
  salePrice,
  setSalePrice,
  sendGoodAddressText,
  setSendGoodAddressText,
}) {
  const { _id } = useParams();
  const location = useLocation();
  const [storeId, setStoreId] = useState("");
  // const [productData, setProductData] = useState(null);
  const fetchData = async (_id) => {
    console.log(_id, "test");
    try {
      const apiUrl = `${process.env.REACT_APP_BASE_URL}/products/getproductV3/${_id}`;
      const response = await axios.get(apiUrl);
      const data = await response;
      console.log(data.data, 'DDDDD')
      if (data && data.data) {
        setProductData(data.data);
        setPrice(data.data.price);
        setQuantity(data.data.quantity);
        // setmOQ(data.data.mOQ);
        setLength(data.data.length);
        setWidth(data.data.width);
        setHeight(data.data.height);
        setUnitWeight(data.data.unitWeight);
        setSuttleWeight(data.data.suttleWeight);
        setStoreId(data.data.supplierId)
        setStoreName(data.data.storeName);
        setSalePrice(data.data.salePrice);
        setSendGoodAddressText(data.data.sendGoodAddressText);
        setFunc(data.data);
      } else {
        console.error("Invalid API response or missing data");
      }
      console.log(formState, '')
      // console.log(data, "testing");
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    // call the api and fetch store data using store id and set store name setStoreName
  }, [storeId])
  useEffect(() => {
    if (_id) {
      // const productId = location.state?.productId;
      fetchData(_id);
    }
    // console.log(_id, "ddddddddddddddd");
  }, [location.state?.productId, _id]);

  const handlePriceChange = (e) => {
    setPrice(e.target.value);
  };
  const handleQuantityChange = (e) => {
    setQuantity(e.target.value);
  };

  const handleLengthChange = (e) => {
    setLength(e.target.value);
  };
  const handleWidthChange = (e) => {
    setWidth(e.target.value);
  };

  const handleHeightChange = (e) => {
    setHeight(e.target.value);
  };

  const handleUnitWeightChange = (e) => {
    setUnitWeight(e.target.value);
  };

  const handlesuttleWeightChange = (e) => {
    setSuttleWeight(e.target.value);
  };

  const handlestoreNameChange = (e) => {
    setStoreName(e.target.value);
  };

  const handleSalePrice = (e) => {
    setSalePrice(e.target.value);
  };
  const handlesendGoodAddressText = (e) => {
    setSendGoodAddressText(e.target.value);
  };

  const handleMOQChange = (e) => {
    console.log(e.target.value, '5555');
    setFunc({ ...data, [e.target.name]: e.target.value });
  };

  // const handleSendGoodsAddressTextChange = (e) => {
  //   setProductData({ ...productData, sendGoodAddressText: e.target.value });
  // };
  const handleDimensionChange = (e, dimension) => {
    const inputValue = e.target.value.trim();

    // Check if the input is a valid non-negative number
    if (inputValue === "" || (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)) {
      setProductData({ ...productData, [dimension]: inputValue });
    }
  };

  const handleWeightChange = (e) => {
    const inputValue = e.target.value.trim();

    // Check if the input is a valid non-negative number
    if (inputValue === "" || (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)) {
      setProductData({ ...productData, unitWeight: inputValue });
    }
  };

  const handlesuttleWeight = (e) => {
    const inputValue = e.target.value.trim();

    // Check if the input is a valid non-negative number
    if (inputValue === "" || (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)) {
      setProductData({ ...productData, suttleWeight: inputValue });
    }
  };
  return (
    <>
      <div style={{ padding: "5px", paddingBottom: "10vh" }}>
        <div style={{ display: "flex", gap: "20px", flexDirection: "column" }}>
          {console.log(data, 'ProductData')}
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Sum Carriage"
            variant="outlined"
            value={data?.sumCarriage ? data?.sumCarriage : ""}
            onChange={(e) => setFunc({ ...data, sumCarriage: e.target.value })}
          />

          {/* {productData && ( */}

          <TextField
            id="outlined-basic"
            label="Price"
            type="text"
            variant="outlined"
            value={data?.defaultPrice ? data?.defaultPrice : ""}
            onChange={(e) => setFunc({ ...data, defaultPrice: e.target.value })}
          />
          {/* )} */}

          {/* <TextField
            id="outlined-basic"
            label="Sale Price"
            type="text"
            variant="outlined"
            value={salePrice}
            onChange={handleSalePrice}
          /> */}

          {/* <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Tax Class"
            variant="outlined"
            value={data?.taxClass?data?.taxClass:""}
            onChange={(e) => setFunc({ ...data, taxClass: e.target.value })}
          /> */}
          {console.log(data, 'DDIIIII')}
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Quantity in Stock"
            type="text"
            variant="outlined"
            // value={quantity}

            value={data?.quantityInStock ? data?.quantityInStock : ""}
          // onChange={(e) => setFunc({ ...data, quantityInStock: e.target.value })}
          // onChange={handleQuantityChange}
          />

          {/* {productData && ( */}
          <TextField
            id="outlined-basic"
            label="MOQ"
            type="text"
            variant="outlined"
            value={data?.mOQ ? data.mOQ : ""}
            // onChange={handleMOQChange}
            onChange={(e) => setFunc({ ...data, mOQ: e.target.value })}

          />
          {/* )} */}

          <TextField
            id="outlined-basic"
            label="Store Name"
            type="text"
            variant="outlined"
            value={data?.storeName ? data.storeName : ""}
            // onChange={handlestoreNameChange}
            onChange={(e) => setFunc({ ...data, storeName: e.target.value })}
          />

          {/* <div className="flex flex-col">
            <span>Subtract Stock</span>
            <select className="h-[7vh] w-[20vw] p-2" name="value" id="">
              <option>Select</option>
              <option>Yes</option>
              <option>No</option>
            </select>
          </div> */}

          <div className="flex flex-col">
            <span>Unit</span>
            <select className="h-[7vh] w-[20vw] p-2" name="value" id=""
              onChange={(e) => setFunc({ ...data, unit: e.target.value })} >
              <option value={data?.unit ? data?.unit : 'Single'}>{data?.unit ? data?.unit : 'Single'}</option>
              <option value="Pair">Pair</option>
              <option value="Set">Set</option>
            </select>
          </div>

          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Send Goods address text"
            variant="outlined"
            value={data?.supplierAddtress ? data.supplierAddtress : ""}
            onChange={(e) => setFunc({ ...data, supplierAddtress: e.target.value })}
          // onChange={handlesendGoodAddressText}


          />

          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Suttle Weight"
            variant="outlined"
            // value={suttleWeight}
            // onChange={handlesuttleWeightChange}
            value={data?.suttleWeight ? data.suttleWeight : ""}
            onChange={(e) => setFunc({ ...data, suttleWeight: e.target.value })}
          />

          <div className="flex flex-col gap-3">
            <span>Dimensions (L x W x H)</span>
            {/* {productData && ( */}
            <div className="flex gap-3">
              <input
                value={data?.length ? data.length : ""}
                onChange={(e) => setFunc({ ...data, length: e.target.value })}
                // value={length}
                // onChange={(e) => handleLengthChange(e, "length")}
                className="w-[20vw] h-[6vh] p-2"
                type="text"
                placeholder="Length"
              />
              <input
                value={data?.width ? data.width : ""}
                onChange={(e) => setFunc({ ...data, width: e.target.value })}

                // value={width}
                // onChange={(e) => handleWidthChange(e, "width")}
                className="w-[20vw] h-[6vh] p-2"
                type="text"
                placeholder="Width"
              />
              <input
                value={data?.height ? data.height : ""}
                onChange={(e) => setFunc({ ...data, height: e.target.value })}
                // value={height}
                // onChange={(e) => handleHeightChange(e, "height")}
                className="w-[20vw] h-[6vh] p-2"
                type="text"
                placeholder="Height"
              />
            </div>
            {/* )} */}
          </div>

          <div className="flex flex-col">
            <span>Length Class</span>
            <select
              value={data.lengthClass ? data.lengthClass : 'cm'}
              onChange={(e) => setFunc({ ...data, lengthClass: e.target.value })}
              className="h-[7vh] w-[20vw] p-2"
              name="value"
              id=""
            >
              <option>Select</option>
              <option value={'cm'}>cm</option>
              <option value={'m'}>m</option>
            </select>
          </div>

          {/* {productData && ( */}
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw", marginTop: "5vh" }}
            label="Weight"
            type="text"
            variant="outlined"
            value={data?.unitWeight ? data.unitWeight : ""}
            onChange={(e) => setFunc({ ...data, unitWeight: e.target.value })}
          />
          {/* )} */}
          <div className="flex flex-col">
            <span>Weight Class</span>
            <select

              value={data.weightClass ? data.weight : "grams"}
              onChange={(e) => setFunc({ ...data, weightClass: e.target.value })}
              className="h-[7vh] w-[20vw] p-2"
              name="value"
              id=""
            >
              <option>Select</option>
              <option value={'grams'}>grams</option>
              <option value={'kgs'}>kgs</option>
            </select>
          </div>

          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Sort Order"
            variant="outlined"
            type="text"
            value={data?.sortOrder}
            onChange={(e) => {
              const inputValue = e.target.value.trim();

              // Check if the input is a valid non-negative number
              if (
                inputValue === "" ||
                (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)
              ) {
                setFunc({ ...data, sortOrder: inputValue });
              }
            }}
          />
          <div style={{ display: "flex", gap: "20px", flexDirection: "column" }}>
            <span>Status</span>
            <select
              value={data.status}
              onChange={(e) => setFunc({ ...data, status: e.target.value === "false" ? false : true })}
              style={{ width: "60vw", height: "5vh" }}
              name=""
              id=""
            >
              <option>Select</option>
              <option value="true">Enabled</option>
              <option value="false">Disabled</option>
            </select>
          </div>
        </div>
      </div>
    </>
  );
}

// component link form for handeling the product form

function LinksForm({ data, setFunc }) {
  return (
    <>
      <div style={{ padding: "5px" }}>
        <div style={{ display: "flex", gap: "20px", flexDirection: "column" }}>
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Seller"
            placeholder="Exmples"
            // value={data?.categoryName}
            // onChange={(e) => setFunc({ ...data, categoryName: e.target.value })}
            variant="outlined"
          />
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Manufacturer"
            placeholder="Exmples"
            // value={data?.categoryName}
            // onChange={(e) => setFunc({ ...data, categoryName: e.target.value })}
            variant="outlined"
          />
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Categories (can be comma separated)"
            placeholder="Men,women,kids"
            // value={data?.categoryName}
            // onChange={(e) => setFunc({ ...data, categoryName: e.target.value })}
            variant="outlined"
          />
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Filters (can be comma separated)"
            placeholder="Men,women,kids"
            // value={data?.categoryName}
            // onChange={(e) => setFunc({ ...data, categoryName: e.target.value })}
            variant="outlined"
          />
          <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
            <span>Stores</span>
            <input
              // checked={data?.pinned}
              // onChange={(e) => setFunc({ ...data, pinned: !data.pinned })}
              style={{ cursor: "pointer" }}
              type="checkbox"
            />
          </div>
        </div>
      </div>
    </>
  );
}

// component to handle attributes form for product

function AttributesForm({ data, setFunc, ruAttribute, setRuAttribute }) {
  const { _id } = useParams();
  const location = useLocation();
  // const [ruAttribute, setRuAttribute] = useState([]);

  const fetchData = async (_id) => {
    console.log(_id, "test");
    try {
      const apiUrl = `${process.env.REACT_APP_BASE_URL}/products/getproductV3/${_id}`;
      const response = await axios.get(apiUrl);
      const data = await response;

      if (data && data.data && data.data.RUattributes) {
        // Split the string into an array of attributes
        setRuAttribute(data.data.RUattributes.split("<br>"));
      } else {
        console.error("Invalid API response or missing data");
      }
      console.log(data, "testing");
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (_id) {
      // const productId = location.state?.productId;
      fetchData(_id);
    }
    console.log(_id, "ddddddddddddddd");
  }, [location.state?.productId, _id]);

  const handleRuAttributeChange = (e) => {
    setRuAttribute(e.target.value);
  };

  return (
    <div style={{ padding: "5px" }}>
      <div className="flex flex-col gap-2">
        <span className="text-sm">Add RU Attributes</span>
        <textarea
          value={ruAttribute}
          placeholder="Enter"
          className="w-[50vw] p-2"
          onChange={handleRuAttributeChange}
          name=""
          id=""
          cols="30"
          rows="10"
        ></textarea>

        {/* <div onChange={handleRuAttributeChange}>
          {ruAttribute.map((attribute, index) => (
            <div key={index}>{attribute}</div>
          ))}
        </div> */}
      </div>
    </div>
  );
}

// component to handle options form for product

function OptionsForm({
  colorOptions,
  setColotherOptions,
  sizeOptions,
  setSizeOptions,
  atttribute3,
  setAttribute3,
  attr1Data,
  setAttr1Data
}) {
  const [selectedOption, setSelectedOption] = useState("att1");

  const handleSelectOption = (opt) => {
    setSelectedOption(opt);
  };

  const handleAddColorAttribute = () => {
    const newData = [...attr1Data];
    newData.push(
      {
        "attr1Value": "",
        "attr1Image": "",
        "sku_id": "",
        "sku_quantity": null,
        "price": "",
        "attr2": [],

      });
    setAttr1Data(newData);
  };



  const handleAddSizeAttribute = () => {
    const newData = [...sizeOptions];
    newData.push({
      value: "",
      selectedValue: "",
      subtractStock: "",

      price: "",

      points: "",

      weight: "",
    });
    setSizeOptions(newData);
  };

  const handleAddAtt3 = () => {
    const newData = [...atttribute3];
    newData.push({
      value: "",
      selectedValue: "",
      subtractStock: "",

      price: "",

      points: "",

      weight: "",
    });
    setAttribute3(newData);
  };

  const handleRemoveSizeAttribute = (idx) => {
    const newData = [...sizeOptions];
    newData.splice(idx, 1);
    setSizeOptions(newData);
  };

  const handleRemoveAtt3 = (idx) => {
    const newData = [...atttribute3];
    newData.splice(idx, 1);
    setAttribute3(newData);
  };
  //onChange the optinos attr
  const [editName, setEditName] = useState('');
  const handleNameChange = (index, name, value) => {
    // setEditName(value);
    console.log(attr1Data, 'attr1Data')
    const updatedArray = attr1Data.map((item, ind) => {
      if (ind == index) return { ...item, [name]: value }
      return item;
    })
    setAttr1Data(updatedArray);


  }
  const removeAttr1 = (idx) => {
    const newData = [...attr1Data];
    newData.splice(idx, 1);
    setAttr1Data(newData);
  };
  const removeAttr2 = async (idx1, idx2) => {
    const newData = [...attr1Data];

    const updatedArray = await newData.map((item1, ind1) => {
      if (ind1 === idx1) {
        console.log(item1, idx2, '99999999888');
        item1.attr2.splice(idx2, 1);
        return item1;
      }
      else
        return item1;
    });
    console.log(updatedArray, idx1, idx2, 'updatedArray');

    setAttr1Data(updatedArray);
  };
  const handleChangeAttr2 = async (index1, index2, name, value) => {

    console.log(attr1Data, 'ITTEM11')
    const updatedArray = await attr1Data.map((item, ind1) => {
      console.log(ind1, index1, index2, 'ITTEM22');
      if (ind1 == index1) {
        const attrRetVal = (item.attr2.map((atr2, ind2) => {
          if (ind2 == index2) {
            return { ...atr2, [name]: value }
          }
          return atr2
        }))
        return { ...item, attr2: attrRetVal }
      }

      return item;
    })
    console.log(updatedArray, 'ITTEMUPPPP');
    setAttr1Data(updatedArray);


  }


  // on change handler of color and size options-:

  const handlChangeColor = (index, name, value) => {
    const newData = [...colorOptions];
    newData[index][name] = value;
    console.log(newData, colorOptions, 'COLOR')
    setColotherOptions(newData);
  };
  const handleChangeSize = (index, name, value, index1) => {
    debugger
    if (name === "price") {
      const newData = [...attr1Data];
      newData[index1].attr2[index][name] = value;
      setAttr1Data(newData);
      return
    }
    const newData = [...attr1Data];
    newData[index1].attr2[index][name] = value;
    setAttr1Data(newData);
    setSizeOptions(newData);
  };

  const handleChangeAtt3 = (index, name, value) => {
    const newData = [...atttribute3];
    newData[index][name] = value;
    setAttribute3(newData);
  };

  const attributesValuesFromFirst = colorOptions.map((c) => c.value);

  const attribute3Values = sizeOptions.map((s) => {
    return {
      value: `${s.selectedValue}/${s.value}`,
    };
  });

  // image change handler for coloroptions-:

  const handleImageChangeColor = async (index, event) => {
    const updatedOptions = [...colorOptions];
    handleImagePreviewColor(index, event);
    setColotherOptions(updatedOptions);



    console.log(event.target.files, 'iiiiiiiiiiiiiiii1111111111')
    const file = event.target.files;
    const formDataFile = new FormData();
    // formDataFile.append('images',file);
    for (let i = 0; i < file.length; i++) {
      formDataFile.append('images', file[i]);
    }
    const resp = await axios.post(`${process.env.REACT_APP_BASE_URL}/products/uploadProductImage`, formDataFile);
    console.log(resp.data, 'iiiiiiiiiiiiii')
    const updatedImagePaths = [...descriptionPaths];
    for (let i = 0; i < resp.data.data.length; i++) {
      // formDataFile.append('images', file[i]);
      // setImagePaths([...imagePaths,resp.data.data]);
      updatedImagePaths.push(resp.data.data[i]);
    }
    setDescriptionPaths(updatedImagePaths);
    setFunc({ ...data, descriptionImages: updatedImagePaths })


  };

  // handle image preview for coloroptions-:

  function handleImagePreviewColor(index, event) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        const updatedOptions = [...colorOptions];
        updatedOptions[index].image = file;
        updatedOptions[index].preview = reader.result;
        setColotherOptions(updatedOptions);
      };

      reader.readAsDataURL(file);
    }
  }

  // image change handler for color options-:

  const handleImageChangeSizes = (index, event) => {
    const updatedOptions = [...sizeOptions];
    handleImagePreviewSize(index, event);
    setSizeOptions(updatedOptions);
  };

  function handleImagePreviewSize(index, event) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        const updatedOptions = [...sizeOptions];
        updatedOptions[index].image = file;
        updatedOptions[index].preview = reader.result;
        setSizeOptions(updatedOptions);
      };

      reader.readAsDataURL(file);
    }
  }

  const handleImageChangeAtt3 = (index, event) => {
    const updatedOptions = [...atttribute3];
    handleImagePreviewAtt3(index, event);
    setAttribute3(updatedOptions);
  };

  function handleImagePreviewAtt3(index, event) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        const updatedOptions = [...atttribute3];
        updatedOptions[index].image = file;
        updatedOptions[index].preview = reader.result;
        setAttribute3(updatedOptions);
      };

      reader.readAsDataURL(file);
    }
  }

  const { _id } = useParams();
  const location = useLocation();
  const [priceData, setPriceData] = useState("");
  const [attr2Data, setAttr2Data] = useState([]);
  const fetchData = async (_id) => {
    console.log(_id, "test");
    try {
      const apiUrl = `${process.env.REACT_APP_BASE_URL}/products/getproductV3/${_id}`;
      const response = await axios.get(apiUrl);
      const data = await response;
      console.log(data.data.variants, 'AttDataa')
      if (data && data.data && data.data.attr2) {
        setAttr2Data(data.data.attr2);
        const parentNames = data.data.attr2.map((item) => item.parentName);
        console.log("Parent Names:", parentNames);
      } else {
        console.error("Invalid API response or missing attr2 data");
      }

      if (data && data.data && data.data.variants) {
        setAttr1Data(data.data.variants);
        console.log(data.data.attr1, 'data.data.attr1');
      } else {
        console.error("Invalid API response or missing attr1 data");
      }
      if (data && data.data && data.data.price) {
        setPriceData(data.data.price);
      } else {
        console.error("Invalid API response or missing price data");
      }

      if (data && data.data && data.data.attr2) {
        setAttr2Data(data.data.attr2);
      } else {
        console.error("Invalid API response or missing attr2 data");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const fetchPriceDetails = async (p_id) => {
    try {
      const apiUrl = `${process.env.REACT_APP_BASE_URL}/products/productPrice/${p_id}`;
      const response = await axios.get(apiUrl);
      const data = await response;
      console.log(data, 'AttDataa111')
      setProductPriceBreakdown(response.data.data);
    }
    catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  useEffect(() => {
    if (_id) {
      // const productId = location.state?.productId;
      fetchData(_id);
    }
    console.log(_id, "ddddddddddddddd");
  }, [location.state?.productId, _id]);

  const handleAttributeChange = (selectedValue) => {
    setSelectedAttributeValue(selectedValue);
  };
  const [openPriceModal, setOpenPriceModal] = useState(false);
  const [productPriceBreakdown, setProductPriceBreakdown] = useState();
  const openPriceModalfunc = (p_id) => {
    setOpenPriceModal(true);
    fetchPriceDetails(p_id);
  }
  const closePriceModalfunc = () => {
    setOpenPriceModal(false);
  }
  const EditProductPriceList = async (p_id) => {
    try {
      const apiUrl = `${process.env.REACT_APP_BASE_URL}/products/productPrice/${p_id}`;
      const Updateddata = {}
      const response = await axios.put(apiUrl, productPriceBreakdown);
      const data = await response;
      console.log(data, 'AttDataa111')
      setProductPriceBreakdown(response.data.data);
    }
    catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  return (
    <>
      <div style={{ padding: "5px" }}>
        <div>
          <button
            type="button"
            style={{ border: "0.5px solid black" }}
            onClick={() => handleSelectOption("att1")}
            className={`rounded-2xl cursor-pointer    ${selectedOption === "att1" ? "bg-blue-700 text-white" : "bg-gray-300 text-black"
              } p-3 w-[7vw]`}
          >
            Attr1
          </button>
          <button
            onClick={() => handleSelectOption("att2")}
            type="button"
            style={{ border: "0.5px solid black" }}
            className={`rounded-2xl cursor-pointer    ${selectedOption === "att2" ? "bg-blue-700 text-white" : "bg-gray-300 text-black"
              } p-3 w-[7vw]`}
          >
            Attr2
          </button>
          <button
            onClick={() => handleSelectOption("att3")}
            type="button"
            style={{ border: "0.5px solid black" }}
            className={`rounded-2xl cursor-pointer    ${selectedOption === "att3" ? "bg-blue-700 text-white" : "bg-gray-300 text-black"
              } p-3 w-[7vw]`}
          >
            Attr3
          </button>
        </div>
        {/* <div className="flex gap-2 mt-4">
          <span
            onClick={() => handleSelectOption("att1")}
            className={` ${
              selectedOption === "att1" ? "bg-gray-100 text-black" : "bg-white"
            } cursor-pointer pt-2 rounded-xl text-center text-sm  w-[7vw]`}
          >
            Attr 1
          </span>
          <span
            onClick={() => handleSelectOption("att2")}
            className={` ${
              selectedOption === "att2" ? "bg-blue-500 text-white" : "bg-white"
            } cursor-pointer text-center  p-3 w-[15vw] rounded-md`}
          >
            Attr 2
          </span>
          <span
            onClick={() => handleSelectOption("att3")}
            className={` ${
              selectedOption === "att3" ? "bg-blue-500 text-white" : "bg-white"
            } cursor-pointer text-center  p-3 w-[15vw] rounded-md`}
          >
            Attr 3
          </span>
        </div> */}

        <div className="mt-4">
          {selectedOption === "att1" && (
            <table>
              <thead>
                <tr>
                  <th className="font-semibold text-md">Name</th>
                  <th>Choose Image</th>
                  <th>Quantity</th>
                  <th>SKU Id</th>
                  {/* <th>Subtract Stock</th> */}
                  <th>Price</th>
                  <th>Discounted price</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>

                {attr1Data.map((c, idx) => {
                    return (

                      <tr key={idx}>
                        <td>
                          <input
                            name="attr1Value"
                            onChange={(e) => handleNameChange(idx, e.target.name, e.target.value)}
                            type="text"
                            value={c.attr1Value}
                            placeholder="Enter Attribute Name"
                            className="p-2 pl-2 w-[15vw]"
                          />
                        </td>
                        <td>
                          <div>
                            <div className="flex flex-col ml-4  gap-3  items-center">
                              <label className="" htmlFor={`profile_pic_${idx}`}>
                                <img
                                  className="rounded-md"
                                  style={{
                                    width: "150px",
                                    height: "40px",
                                    objectFit: "contain",
                                    cursor: "pointer",
                                    borderRadius: "5px",
                                  }}
                                  src={c.attr1Image}
                                  alt="temp_img"
                                />
                              </label>
                            </div>

                            <input
                              name="image"
                              id={`profile_pic_${idx}`}
                              style={{ display: "none" }}
                              type="file"
                              accept="image/*"
                              onChange={(e) => handleImageChangeColor(idx, e)}
                            />
                          </div>
                        </td>
                        <td>
                          <input
                            placeholder="Enter Quantity"
                            value={c.sku_quantity}
                            name="sku_quantity"
                            onChange={(e) => handleNameChange(idx, e.target.name, e.target.value)}
                            // name="quantity"
                            // onChange={(e) => {
                            //   const inputValue = e.target.value.trim();
                            //   if (
                            //     inputValue === "" ||
                            //     (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)
                            //   ) {
                            //     handlChangeColor(idx, e.target.name, e.target.value);
                            //   }
                            // }}
                            type="text"
                            className="w-[10vw] p-2 h-[6vh]"
                          />
                        </td>
                        <td>
                          <p style={{ fontSize: "14px" }}>
                            {c.sku_id}
                          </p>
                        </td>
                        {/* <td>
                          <select
                            value={c.subtractStock}
                            onChange={(e) => handlChangeColor(idx, e.target.name, e.target.value)}
                            className="h-[6vh] w-[7vw] p-2"
                            name="subtractStock"
                            id=""
                          >
                            <option selected>Select</option>
                            <option>Yes</option>
                            <option>No</option>
                          </select>
                        </td> */}
                        <td>
                          <input
                            placeholder="Enter Price "
                            value={c.price}
                            name="price"
                            onChange={(e) => handleNameChange(idx, e.target.name, e.target.value)}
                            // onChange={(e) => setPriceData(e.target.value)}
                            // onChange={(e) => {
                            //   const inputValue = e.target.value.trim();
                            //   if (
                            //     inputValue === "" ||
                            //     (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)
                            //   ) {
                            //     handlChangeColor(idx, e.target.name, e.target.value);
                            //   }
                            // }}
                            type="text"
                            className="w-[10vw] p-2 h-[6vh]"
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            value={c.sellingprice}
                            onChange={(e) => {
                              const inputValue = e.target.value.trim();
                              if (
                                inputValue === "" ||
                                (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)
                              ) {
                                handlChangeColor(idx, e.target.name, e.target.value);
                              }
                            }}
                            name="sellingprice"
                            placeholder="Enter Selling Price"
                            className="w-[7vw] p-2 h-[6vh]"
                          />
                        </td>
                        <td>
                          <button
                            // disabled={colorOptions.length <= 1}
                            onClick={() => removeAttr1(idx)}
                            type="button"
                            className="border-none outline-none bg-transparent"
                          >
                            <IoIosRemoveCircleOutline className="text-xl cursor-pointer text-red-700" />
                          </button>
                        </td>
                      </tr>
                    )
      
                })}
              </tbody>
            </table>
          )}
        </div>

        <div className="mt-4">
          {selectedOption === "att2" && (
            <table>
              <thead>
                <tr>
                  <th className="font-semibold text-md">Name</th>
                  <th>Parent</th>
                  {/* <th>Choose Image</th> */}
                  <th>Quantity</th>
                  <th>SKU Id</th>
                  {/* <th>Subtract Stock</th> */}
                  <th>Price</th>
                  <th>Discounted price</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {attr1Data?.map((attr1D, index1) => {
                  // console.log(attr1D['attr2'],'SIZE1')

                  return (attr1D['attr2']?.map((size, idx) => {
                    console.log(size, 'SIZE2')

                    return (
                      <tr key={idx}>
                        <td>
                          <input
                            name="attr2Value"
                            onChange={(e) => handleChangeAttr2(index1, idx, e.target.name, e.target.value)}
                            type="text"
                            value={size.attr2Value}
                            placeholder="Enter Attribute Name"
                            className="p-2 pl-2 w-[15vw]"
                          />
                        </td>
                        <td>
                          {/* <div className="flex flex-col gap-3">
                          <select
                            onChange={(e) => handleAttributeChange(e.target.value)}
                            className="w-[12vw] h-[6vh] p-2"
                            value={parentName}
                          >
                            <option value="">Select an option</option>
                            {parentNameFromFirsts.map((parentName, index) => (
                              <option key={index}>{parentName}</option>
                            ))}
                          </select>
                        </div> */}
                          <input
                            name="attr1Value"
                            onChange={(e) => handleNameChange(index1, e.target.name, e.target.value)}
                            type="text"
                            value={attr1D.attr1Value}
                            placeholder="Enter Attribute Name"
                            className="p-2 pl-2 w-[15vw]"
                          />
                        </td>
                        {/* <td>
                        <div>
                          <div className="flex flex-col ml-4  gap-3  items-center">
                            <label className="" htmlFor={`profile_pic_${idx}`}>
                              <img
                                className="rounded-md"
                                style={{
                                  width: "150px",
                                  height: "40px",
                                  objectFit: "contain",
                                  cursor: "pointer",
                                  borderRadius: "5px",
                                }}
                                src={size?.preview ? size?.preview : placeholder}
                                alt="temp_img"
                              />
                            </label>
                          </div>

                          <input
                            id={`profile_pic_${idx}`}
                            style={{ display: "none" }}
                            type="file"
                            accept="image/*"
                            onChange={(e) => handleImageChangeSizes(idx, e)}
                          />
                        </div>
                      </td> */}
                        <td>
                          <input
                            placeholder="Enter Quantity"
                            value={size.sku_quantity}
                            // onChange={(e) => {
                            //   const inputValue = e.target.value.trim();
                            //   if (
                            //     inputValue === "" ||
                            //     (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)
                            //   ) {
                            //     handleChangeSize(idx, e.target.name, e.target.value, index1);
                            //   }
                            // }}
                            onChange={(e) => handleChangeAttr2(index1, idx, e.target.name, e.target.value)}
                            type="text"
                            name="sku_quantity"
                            className="w-[10vw] p-2 h-[6vh]"
                          />
                        </td>
                        <td>
                          <input
                            placeholder="Enter SKU Id"
                            value={size.sku_id}
                            type="text"
                            name="sku_id"
                            className="w-[10vw] p-2 h-[6vh]"
                          />
                        </td>
                        {/* <td>
                        <select
                          value={size.subtractStock}
                          onChange={(e) => handleChangeSize(idx, e.target.name, e.target.value, index1)}
                          className="h-[6vh] w-[7vw] p-2"
                          name="subtractStock"
                          id=""
                        >
                          <option>Select</option>
                          <option>Yes</option>
                          <option>No</option>
                        </select>
                      </td> */}
                        <td>
                          <input
                            placeholder="Enter Price "
                            value={size.price}
                            // onChange={(e) => setPriceData(e.target.value)}
                            onChange={(e) => handleChangeAttr2(index1, idx, e.target.name, e.target.value)}

                            type="text"
                            name="price"
                            className="w-[10vw] p-2 h-[6vh]"
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            value={size.discountPrice}
                            onChange={(e) => handleChangeAttr2(index1, idx, e.target.name, e.target.value)}
                            // onChange={(e) => {
                            //   const inputValue = e.target.value.trim();
                            //   if (
                            //     inputValue === "" ||
                            //     (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)
                            //   ) {
                            //     handleChangeSize(idx, e.target.name, e.target.value, index1);
                            //   }
                            // }}
                            name="discountPrice"
                            placeholder="Enter Selling Price"
                            className="w-[7vw] p-2 h-[6vh]"
                          />
                        </td>
                        <td>
                          {console.log(size, 'SIZE')}
                          <IconButton onClick={() => openPriceModalfunc(size._id)}>
                            <MdOutlinePreview style={{ cursor: "pointer" }} />
                          </IconButton>
                          <button
                            // disabled={sizeOptions.length <= 1}
                            onClick={() => removeAttr2(idx, index1)}
                            type="button"
                            className="border-none outline-none bg-transparent"
                          >
                            <IoIosRemoveCircleOutline className="text-xl cursor-pointer text-red-700" />
                          </button>

                        </td>
                      </tr>
                    );
                  }))

                })}
              </tbody>
            </table>
          )}
        </div>
        <div className="mt-4">
          {selectedOption === "att3" && (
            <table>
              <thead>
                <tr>
                  <th className="font-semibold text-md">Name</th>
                  <th>Parent</th>
                  <th>Choose Image</th>
                  <th>Quantity</th>
                  <th>SKU Id</th>
                  <th>Subtract Stock</th>
                  {/* <th>Price</th> */}
                  <th>Discounted Price</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {atttribute3.map((att, idx) => {
                  return (
                    <tr key={idx}>
                      <td>
                        <input
                          name="value"
                          value={att.value}
                          onChange={(e) => handleChangeAtt3(idx, e.target.name, e.target.value)}
                          type="text"
                          placeholder="Enter Attribute Name"
                          className="p-2 pl-2 w-[15vw]"
                        />
                      </td>
                      <td>
                        <div className="flex flex-col gap-3">
                          <select
                            name="selectedValue"
                            value={att.selectedValue}
                            onChange={(e) => handleChangeAtt3(idx, e.target.name, e.target.value)}
                            className="w-[12vw] h-[6vh] p-2"
                          >
                            <option>Select</option>
                            {attribute3Values.map((att, index) => {
                              return <option key={index}>{att.value}</option>;
                            })}
                          </select>
                        </div>
                      </td>
                      <td>
                        <div>
                          <div className="flex flex-col ml-4  gap-3  items-center">
                            <label className="" htmlFor={`profile_pic_${idx}`}>
                              <img
                                className="rounded-md"
                                style={{
                                  width: "150px",
                                  height: "40px",
                                  objectFit: "contain",
                                  cursor: "pointer",
                                  borderRadius: "5px",
                                }}
                                src={att?.preview ? att?.preview : placeholder}
                                alt="temp_img"
                              />
                            </label>
                          </div>

                          <input
                            id={`profile_pic_${idx}`}
                            style={{ display: "none" }}
                            type="file"
                            accept="image/*"
                            onChange={(e) => handleImageChangeAtt3(idx, e)}
                          />
                        </div>
                      </td>
                      <td>
                        <input
                          placeholder="Enter Quantity"
                          value={att.quantity}
                          onChange={(e) => {
                            const inputValue = e.target.value.trim();
                            if (
                              inputValue === "" ||
                              (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)
                            ) {
                              handleChangeAtt3(idx, e.target.name, e.target.value);
                            }
                          }}
                          type="text"
                          name="quantity"
                          className="w-[10vw] p-2 h-[6vh]"
                        />
                      </td>
                      <td>
                        <input
                          placeholder="Enter Quantity"
                          value={att.sku_id}
                          onChange={(e) => {
                            const inputValue = e.target.value.trim();
                            if (
                              inputValue === "" ||
                              (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)
                            ) {
                              handleChangeSize(idx, e.target.name, e.target.value);
                            }
                          }}
                          type="text"
                          name="sku_id"
                          className="w-[10vw] p-2 h-[6vh]"
                        />
                      </td>
                      <td>
                        <select
                          value={att.subtractStock}
                          onChange={(e) => handleChangeAtt3(idx, e.target.name, e.target.value)}
                          className="h-[6vh] w-[7vw] p-2"
                          name="subtractStock"
                          id=""
                        >
                          <option>Select</option>
                          <option>Yes</option>
                          <option>No</option>
                        </select>
                      </td>
                      {/* <td>
                        <input
                          placeholder="Enter Price "
                          value={att.price}
                          onChange={(e) => {
                            const inputValue = e.target.value.trim();
                            if (
                              inputValue === "" ||
                              (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)
                            ) {
                              handleChangeAtt3(idx, e.target.name, e.target.value);
                            }
                          }}
                          type="text"
                          name="price"
                          className="w-[10vw] p-2 h-[6vh]"
                        />
                      </td> */}
                      <td>
                        <input
                          type="text"
                          value={att.sellingprice}
                          onChange={(e) => {
                            const inputValue = e.target.value.trim();
                            if (
                              inputValue === "" ||
                              (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)
                            ) {
                              handleChangeAtt3(idx, e.target.name, e.target.value);
                            }
                          }}
                          name="sellingprice"
                          placeholder="Enter Selling Price"
                          className="w-[7vw] p-2 h-[6vh]"
                        />
                      </td>
                      <td>
                        <button
                          // disabled={atttribute3.length <= 1}
                          onClick={() => handleRemoveAtt3(idx)}
                          type="button"
                          className="border-none outline-none bg-transparent"
                        >
                          <IoIosRemoveCircleOutline className="text-xl cursor-pointer text-red-700" />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
        {selectedOption === "att1" ? (
          <div className="flex justify-start ">
            <button
              type="button"
              className="bg-green-600 mt-4 text-white p-2 rounded-md border-none outline-none cursor-pointer"
              onClick={handleAddColorAttribute}
            >
              Add{" "}
            </button>
          </div>
        ) : selectedOption === "att2" ? (
          <div className="flex justify-start ">
            <button
              type="button"
              className="bg-green-600 mt-4 text-white p-2 rounded-md border-none outline-none cursor-pointer"
              onClick={handleAddSizeAttribute}
            >
              Add{" "}
            </button>
          </div>
        ) : selectedOption === "att3" ? (
          <div className="flex justify-start ">
            <button
              type="button"
              className="bg-green-600 mt-4 text-white p-2 rounded-md border-none outline-none cursor-pointer"
              onClick={handleAddAtt3}
            >
              Add{" "}
            </button>
          </div>
        ) : null}
      </div>
      <ModalComponent
        title={"Price Details"}
        open={openPriceModal}
        handleClose={closePriceModalfunc}
      >
        <div style={{ position: "relative" }}>
          {/* <button >Edit</button> */}
          <div
            style={{ position: "absolute", right: "20px" }}
          >

            <Button
              type={"button"}
              cliclHandler={() => EditProductPriceList(productPriceBreakdown?.varientId)}
              title={"Save"}
              background={"green"}
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "24px", width: "600px" }}>
            {console.log(productPriceBreakdown, 'productPriceBreakdown')}
            <div>
              <label style={{ display: "inline-block", width: "100px" }}>Original Price</label>
              <input
                type="text"
                value={productPriceBreakdown?.originalPrice}
                placeholder="originalPrice"
                onChange={(e) => { setProductPriceBreakdown({ ...productPriceBreakdown, originalPrice: e.target.value }) }}
                style={{ height: "24px", border: "1px solid gray", borderRadius: "4px", padding: "4px 10px", margin: "2px 10px" }}
              />
            </div>
            <div>
              <label style={{ display: "inline-block", width: "100px" }}>Discount</label>
              <input type="text"
                onChange={(e) => { setProductPriceBreakdown({ ...productPriceBreakdown, discount: e.target.value }) }}
                value={productPriceBreakdown?.discount} placeholder="originalPrice" style={{ height: "24px", border: "1px solid gray", borderRadius: "4px", padding: "4px 10px", margin: "2px 10px" }} />
            </div>
            <div>
              <label style={{ display: "inline-block", width: "100px" }}>Tax</label>
              <input type="text"
                onChange={(e) => { setProductPriceBreakdown({ ...productPriceBreakdown, tax: e.target.value }) }}
                value={productPriceBreakdown?.tax} placeholder="originalPrice" style={{ height: "24px", border: "1px solid gray", borderRadius: "4px", padding: "4px 10px", margin: "2px 10px" }} />
            </div>
            <div>
              <p style={{ fontWeight: "700" }}>
                Price By Size :
              </p>
              <div style={{ margin: "10px 20px", display: "flex", flexDirection: "column" }}>
                <div>
                  <label style={{ display: "inline-block", width: "200px" }}>By Air</label>
                  <input type="text"
                    onChange={(e) => {
                      // Create a new array by copying the existing priceBySize array
                      let newPriceBySize = [...productPriceBreakdown.priceBySize];

                      // Update the 'byAir' property of the first element in the new array
                      if (newPriceBySize.length > 0) {
                        newPriceBySize[0] = {
                          ...newPriceBySize[0],
                          byAir: e.target.value
                        };
                      }

                      // Set the updated array back to the state
                      setProductPriceBreakdown({
                        ...productPriceBreakdown,
                        priceBySize: newPriceBySize
                      });
                    }}
                    value={productPriceBreakdown?.priceBySize[0]?.byAir} placeholder="originalPrice" style={{ height: "24px", border: "1px solid gray", borderRadius: "4px", padding: "4px 10px", margin: "2px 10px" }} />
                </div>
                <div>

                  <label style={{ display: "inline-block", width: "200px" }}>By Train</label>
                  <input type="text" 
                   onChange={(e) => {
                      // Create a new array by copying the existing priceBySize array
                      let newPriceBySize = [...productPriceBreakdown.priceBySize];

                      // Update the 'byAir' property of the first element in the new array
                      if (newPriceBySize.length > 0) {
                        newPriceBySize[0] = {
                          ...newPriceBySize[0],
                          byTrain: e.target.value
                        };
                      }

                      // Set the updated array back to the state
                      setProductPriceBreakdown({
                        ...productPriceBreakdown,
                        priceBySize: newPriceBySize
                      });
                    }}
                  value={productPriceBreakdown?.priceBySize[0]?.byTrain} placeholder="originalPrice" style={{ height: "24px", border: "1px solid gray", borderRadius: "4px", padding: "4px 10px", margin: "2px 10px" }} />
                </div>
                <div>

                  <label style={{ display: "inline-block", width: "200px" }}>Profit of Percentage</label>
                  <input type="text" 
                   onChange={(e) => {
                      // Create a new array by copying the existing priceBySize array
                      let newPriceBySize = [...productPriceBreakdown.priceBySize];

                      // Update the 'byAir' property of the first element in the new array
                      if (newPriceBySize.length > 0) {
                        newPriceBySize[0] = {
                          ...newPriceBySize[0],
                          profitOfPercentage: e.target.value
                        };
                      }

                      // Set the updated array back to the state
                      setProductPriceBreakdown({
                        ...productPriceBreakdown,
                        priceBySize: newPriceBySize
                      });
                    }}
                  value={productPriceBreakdown?.priceBySize[0]?.profitOfPercentage} placeholder="originalPrice" style={{ height: "24px", border: "1px solid gray", borderRadius: "4px", padding: "4px 10px", margin: "2px 10px" }} />
                </div>
                <div>

                  <label style={{ display: "inline-block", width: "200px" }}>Shipping Charges</label>
                  <input type="text" 
                  onChange={(e) => {
                      // Create a new array by copying the existing priceBySize array
                      let newPriceBySize = [...productPriceBreakdown.priceBySize];

                      // Update the 'byAir' property of the first element in the new array
                      if (newPriceBySize.length > 0) {
                        newPriceBySize[0] = {
                          ...newPriceBySize[0],
                          shippingCharge: e.target.value
                        };
                      }

                      // Set the updated array back to the state
                      setProductPriceBreakdown({
                        ...productPriceBreakdown,
                        priceBySize: newPriceBySize
                      });
                    }}
                  value={productPriceBreakdown?.priceBySize[0]?.shippingCharge} placeholder="originalPrice" style={{ height: "24px", border: "1px solid gray", borderRadius: "4px", padding: "4px 10px", margin: "2px 10px" }} />
                </div>

              </div>
            </div>
            <div>
              <p style={{ fontWeight: "700" }}>
                Price By Weight :
              </p>
              <div style={{ margin: "10px 20px", display: "flex", flexDirection: "column" }}>
                <div>

                  <label style={{ display: "inline-block", width: "200px" }}>By Air</label>
                  <input type="text"
                  onChange={(e) => {
                      // Create a new array by copying the existing priceBySize array
                      let newPriceByWeight = [...productPriceBreakdown.priceByWeight];

                      // Update the 'byAir' property of the first element in the new array
                      if (newPriceByWeight.length > 0) {
                        newPriceByWeight[0] = {
                          ...newPriceByWeight[0],
                          byAir: e.target.value
                        };
                      }

                      // Set the updated array back to the state
                      setProductPriceBreakdown({
                        ...productPriceBreakdown,
                        priceByWeight: newPriceByWeight
                      });
                    }}
                   value={productPriceBreakdown?.priceByWeight[0]?.byAir} placeholder="originalPrice" style={{ height: "24px", border: "1px solid gray", borderRadius: "4px", padding: "4px 10px", margin: "2px 10px" }} />
                </div>
                <div>

                  <label style={{ display: "inline-block", width: "200px" }}>By Train</label>
                  <input type="text"
                  onChange={(e) => {
                      // Create a new array by copying the existing priceBySize array
                      let newPriceByWeight = [...productPriceBreakdown.priceByWeight];

                      // Update the 'byAir' property of the first element in the new array
                      if (newPriceByWeight.length > 0) {
                        newPriceByWeight[0] = {
                          ...newPriceByWeight[0],
                          byTrain: e.target.value
                        };
                      }

                      // Set the updated array back to the state
                      setProductPriceBreakdown({
                        ...productPriceBreakdown,
                        priceByWeight: newPriceByWeight
                      });
                    }}
                   value={productPriceBreakdown?.priceByWeight[0]?.byTrain} placeholder="originalPrice" style={{ height: "24px", border: "1px solid gray", borderRadius: "4px", padding: "4px 10px", margin: "2px 10px" }} />
                </div>
                <div>

                  <label style={{ display: "inline-block", width: "200px" }}>Profit of Percentage</label>
                  <input type="text"
                  onChange={(e) => {
                      // Create a new array by copying the existing priceBySize array
                      let newPriceByWeight = [...productPriceBreakdown.priceByWeight];

                      // Update the 'byAir' property of the first element in the new array
                      if (newPriceByWeight.length > 0) {
                        newPriceByWeight[0] = {
                          ...newPriceByWeight[0],
                          profitOfPercentage: e.target.value
                        };
                      }

                      // Set the updated array back to the state
                      setProductPriceBreakdown({
                        ...productPriceBreakdown,
                        priceByWeight: newPriceByWeight
                      });
                    }}
                   value={productPriceBreakdown?.priceByWeight[0]?.profitOfPercentage} placeholder="originalPrice" style={{ height: "24px", border: "1px solid gray", borderRadius: "4px", padding: "4px 10px", margin: "2px 10px" }} />
                </div>
                <div>

                  <label style={{ display: "inline-block", width: "200px" }}>Shipping Charges</label>
                  <input type="text"
                  onChange={(e) => {
                      // Create a new array by copying the existing priceBySize array
                      let newPriceByWeight = [...productPriceBreakdown.priceByWeight];

                      // Update the 'byAir' property of the first element in the new array
                      if (newPriceByWeight.length > 0) {
                        newPriceByWeight[0] = {
                          ...newPriceByWeight[0],
                          shippingCharge: e.target.value
                        };
                      }

                      // Set the updated array back to the state
                      setProductPriceBreakdown({
                        ...productPriceBreakdown,
                        priceByWeight: newPriceByWeight
                      });
                    }}
                   value={productPriceBreakdown?.priceByWeight[0]?.shippingCharge} placeholder="originalPrice" style={{ height: "24px", border: "1px solid gray", borderRadius: "4px", padding: "4px 10px", margin: "2px 10px" }} />
                </div>

              </div>
            </div>


          </div>
        </div>

      </ModalComponent>
    </>
  );
}

// sizes form

function SizeForm({ data, setFunc }) {
  return (
    <>
      <div style={{ padding: "5px" }}>
        <div className="flex flex-col gap-4">
          <TextField
            value={data.size1}
            onChange={(e) => setFunc({ ...data, size1: e.target.value })}
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Size 1"
            variant="outlined"
          />
          <TextField
            value={data.size2}
            onChange={(e) => setFunc({ ...data, size2: e.target.value })}
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Size 2"
            variant="outlined"
          />
          <TextField
            value={data.size3}
            onChange={(e) => setFunc({ ...data, size3: e.target.value })}
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Size 3"
            variant="outlined"
          />
          <TextField
            value={data.size4}
            onChange={(e) => setFunc({ ...data, size4: e.target.value })}
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Size 4"
            variant="outlined"
          />
          <TextField
            value={data.size5}
            onChange={(e) => setFunc({ ...data, size5: e.target.value })}
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Size 5"
            variant="outlined"
          />
          <TextField
            value={data.size6}
            onChange={(e) => setFunc({ ...data, size6: e.target.value })}
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Size 6"
            variant="outlined"
          />
          <TextField
            value={data.size7}
            onChange={(e) => setFunc({ ...data, size8: e.target.value })}
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Size 7"
            variant="outlined"
          />
          <TextField
            value={data.size8}
            onChange={(e) => setFunc({ ...data, size8: e.target.value })}
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Size 8"
            variant="outlined"
          />
        </div>
      </div>
    </>
  );
}

// component to handle images of product form
function ImageForm({ categoryImages, setCategoryImages, categoryVid, setCategoryVid, data, setFunc }) {
  // add more images-:

  const handleAddImages = () => {
    const newData = [...categoryImages];
    newData.push({
      image: "",
      preview: "",
    });
    setCategoryImages(newData);
  };

  const handleImageChange = (index, event) => {
    const updatedOptions = [...categoryImages];
    handleImagePreview(index, event);
    setCategoryImages(updatedOptions);
  };

  function handleImagePreview(index, event) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        const updatedOptions = [...categoryImages];
        updatedOptions[index].image = file;
        updatedOptions[index].preview = reader.result;
        setCategoryImages(updatedOptions);
      };

      reader.readAsDataURL(file);
    }
  }

  const removeImageHandler = (idx) => {
    const updatedImagePaths = [...imagePaths];
    updatedImagePaths.splice(idx, 1);
    setImagePaths(updatedImagePaths);
    setFunc({ ...data, mainImages: updatedImagePaths })
  };
  const removeImageHandler2 = (idx) => {
    const updatedDescriptionPaths = [...descriptionPaths];
    updatedDescriptionPaths.splice(idx, 1);
    setDescriptionPaths(updatedDescriptionPaths);
    setFunc({ ...data, descriptionImages: updatedDescriptionPaths })

  };
  console.log(categoryImages);

  const handleVidChange = (event) => {
    const file = event.target.files[0];

    if (file && file.type.startsWith("video/")) {
      // Check if the selected file is a video
      setCategoryVid(URL.createObjectURL(file));
    } else {
      // Clear the selected video if the file is not a video
      setCategoryVid(null);
    }
  };
  const handelDescriptionPathAdd = async (event) => {
    console.log(event.target.files, 'iiiiiiiiiiiiiiii1111111111')
    const file = event.target.files;
    const formDataFile = new FormData();
    // formDataFile.append('images',file);
    for (let i = 0; i < file.length; i++) {
      formDataFile.append('images', file[i]);
    }
    const resp = await axios.post(`${process.env.REACT_APP_BASE_URL}/products/uploadProductImage`, formDataFile);
    console.log(resp.data, 'iiiiiiiiiiiiii')
    const updatedImagePaths = [...descriptionPaths];
    for (let i = 0; i < resp.data.data.length; i++) {
      // formDataFile.append('images', file[i]);
      // setImagePaths([...imagePaths,resp.data.data]);
      updatedImagePaths.push(resp.data.data[i]);
    }
    setDescriptionPaths(updatedImagePaths);
    setFunc({ ...data, descriptionImages: updatedImagePaths })

  }
  const handleImagePathAdd = async (event) => {
    console.log(event.target.files, 'iiiiiiiiiiiiiiii1111111111')
    const file = event.target.files;
    const formDataFile = new FormData();
    // formDataFile.append('images',file);
    for (let i = 0; i < file.length; i++) {
      formDataFile.append('images', file[i]);
    }
    const resp = await axios.post(`${process.env.REACT_APP_BASE_URL}/products/uploadProductImage`, formDataFile);
    console.log(resp.data, 'iiiiiiiiiiiiii')
    const updatedImagePaths = [...imagePaths];
    for (let i = 0; i < resp.data.data.length; i++) {
      // formDataFile.append('images', file[i]);
      // setImagePaths([...imagePaths,resp.data.data]);
      updatedImagePaths.push(resp.data.data[i]);
    }
    setImagePaths(updatedImagePaths);
    setFunc({ ...data, mainImages: updatedImagePaths })

  }

  const { _id } = useParams();
  const location = useLocation();
  const [imagePaths, setImagePaths] = useState([]);
  const [descriptionPaths, setDescriptionPaths] = useState([]);
  const [productId, setProductId] = useState(null);

  const fetchData = async (_id) => {
    console.log(_id, "test");
    try {
      const apiUrl = `${process.env.REACT_APP_BASE_URL}/products/getproductV3/${_id}`;
      const response = await axios.get(apiUrl);
      const data = await response.data;
      console.log(data, 'DDDD)))')

      const { mainImages, descriptionImages } = data;
      setImagePaths(mainImages);
      setDescriptionPaths(descriptionImages);
      console.log(data, "testing");
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (_id) {
      fetchData(_id);
    }
    console.log(_id, "ddddddddddddddd");
  }, [location.state?.productId, _id]);

  return (
    <>
      <div style={{ padding: "5px" }}>
        <div className="flex flex-col">
          <span className="text-sm">Choose Video</span>
          <label htmlFor="cate_vid">
            <img
              className="rounded-md"
              style={{
                width: "100px",
                height: "40px",
                objectFit: "contain",
                cursor: "pointer",
                borderRadius: "5px",
              }}
              src={placeholder}
              alt="temp_img"
            />
            <input
              type="file"
              onChange={handleVidChange}
              id="cate_vid"
              accept="video/mp4,video/x-m4v,video/*"
              className="hidden"
            />
          </label>
          {categoryVid && (
            <div>
              <p className="text-sm">Video Preview:</p>
              <video width="320" height="240" controls>
                <source src={categoryVid} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          )}
        </div>
        <hr />
        {/* <div className="flex flex-col mt-4 gap-4">
          <div className="flex flex-col gap-3">
            {categoryImages.map((c, idx) => {
              return (
                <div className="flex flex-col gap-2" key={idx}>
                  <span className="text-sm">Images Path</span>
                  <label htmlFor={`category_${idx}`}>
                    <img
                      className="rounded-md"
                      style={{
                        width: "100px",
                        height: "40px",
                        objectFit: "contain",
                        cursor: "pointer",
                        borderRadius: "5px",
                      }}
                      src={c?.preview ? c?.preview : placeholder}
                      alt="temp_img"
                    />
                    <input
                      type="file"
                      className="hidden"
                      id={`category_${idx}`}
                      onChange={(e) => handleImageChange(idx, e)}
                    />
                    <button
                      // disabled={colorOptions.length <= 1}
                      onClick={() => removeImageHandler(idx)}
                      type="button"
                      className="border-none outline-none bg-transparent"
                    >
                      <IoIosRemoveCircleOutline className="text-xl cursor-pointer text-red-700" />
                    </button>
                  </label>
                  <div className="image-container">
                    {imagePaths.map((path, index) => (
                      <img
                        key={index}
                        src={path}
                        alt={`Image ${index + 1}`}
                        style={{ width: "70px", height: "100px", margin: "5px" }}
                      />
                    ))}
                  </div>
                </div>
              );
            })}
          </div>

          <div className="flex flex-col gap-3">
            {categoryImages.map((c, idx) => {
              return (
                <div className="flex flex-col gap-2" key={idx}>
                  <span className="text-sm">Descriptions Path</span>
                  <label htmlFor={`category_${idx}`}>
                    <img
                      className="rounded-md"
                      style={{
                        width: "100px",
                        height: "40px",
                        objectFit: "contain",
                        cursor: "pointer",
                        borderRadius: "5px",
                      }}
                      src={c?.preview ? c?.preview : placeholder}
                      alt="temp_img"
                    />
                    <input
                      type="file"
                      className="hidden"
                      id={`category_${idx}`}
                      onChange={(e) => handleImageChange(idx, e)}
                    />
                    <button
                      // disabled={selectedOption.length <= 1}
                      onClick={() => removeImageHandler2(idx)}
                      type="button"
                      className="border-none outline-none bg-transparent"
                    >
                      <IoIosRemoveCircleOutline className="text-xl cursor-pointer text-red-700" />
                    </button>
                  </label>
                  <div>
                    <div className="image-container">
                      {descriptionPaths.map((path, index) => (
                        <img
                          key={index}
                          src={path}
                          alt={`Description Image ${index + 1}`}
                          style={{ width: "70px", height: "100px", margin: "5px" }}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div>
            <Button
              cliclHandler={handleAddImages}
              type={"button"}
              title={"Add"}
              background={"blue"}
            />
          </div>
        </div> */}

        <div className="flex flex-col mt-4 gap-4">
          <span className="text-sm">Images Path</span>
          <div className="flex flex-row flex-wrap gap-3">
            {imagePaths.map((path, idx) => (
              <div className="flex flex-col gap-2 relative" key={idx}>
                <div className="image-container relative">
                  <img
                    src={path}
                    alt={`Image ${idx + 1}`}
                    style={{ width: "70px", height: "100px", margin: "5px" }}
                  />
                  <CloseIcon
                    className="text-xl cursor-pointer text-red-700 absolute top-0 right-0"
                    onClick={() => removeImageHandler(idx)}
                    style={{ width: "15px" }}
                  />
                </div>
              </div>
            ))}
            {/* <span className="text-sm">Choose Video</span> */}
            <label htmlFor="cate_img" style={{ display: "flex", alignItems: "center" }}>
              <img
                className="rounded-md"
                style={{
                  width: "100px",
                  height: "40px",
                  objectFit: "contain",
                  cursor: "pointer",
                  borderRadius: "5px",
                }}
                src={placeholder}
                alt="temp_img"
              />
              <input
                type="file"
                onChange={handleImagePathAdd}
                id="cate_img"
                multiple
                // accept="image/jpg,video/x-m4v,video/*"
                className="hidden"
              />
            </label>
          </div>
        </div>

        <span className="text-sm">Descriptions Path</span>
        <div className="flex gap-3">
          {descriptionPaths.map((path, idx) => (
            <div className="flex flex-col gap-2" key={idx}>
              <div className="image-container relative">
                <img
                  src={path}
                  alt={`Description Image ${idx + 1}`}
                  style={{ width: "70px", height: "100px", margin: "5px" }}
                />
                <CloseIcon
                  className="text-xl cursor-pointer text-red-700 absolute top-0 right-0"
                  onClick={() => removeImageHandler2(idx)}
                />
              </div>
            </div>
          ))}
          <label htmlFor="cate_des" style={{ display: "flex", alignItems: "center" }}>
            <img
              className="rounded-md"
              style={{
                width: "100px",
                height: "40px",
                objectFit: "contain",
                cursor: "pointer",
                borderRadius: "5px",
              }}
              src={placeholder}
              alt="temp_des"
            />
            <input
              type="file"
              onChange={handelDescriptionPathAdd}
              id="cate_des"
              multiple
              // accept="image/jpg,video/x-m4v,video/*"
              className="hidden"
            />
          </label>
        </div>

        {/* Add Button */}
        {/* <div>
          <Button
            clickHandler={handleAddImages}
            type={"file"}
            title={"Add"}
            background={"blue"}
          />
        </div> */}
      </div>
    </>
  );
}

function SeoForm({ data, setFunc }) {
  return (
    <>
      <div style={{ padding: "5px" }}>
        <div style={{ display: "flex", gap: "20px", flexDirection: "column" }}>
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Keywords"
            variant="outlined"
          />
        </div>
      </div>
    </>
  );
}